var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:{ 'red--text': _vm.value < 0 }},[_vm._v(_vm._s(_vm._f("decimal")(_vm.value)))])}
var staticRenderFns = []

export { render, staticRenderFns }